const primitives = {
  'neon-blue': {
    100: '#DAD9FF',
    200: '#B7B6FF',
    300: '#A6A4FD',
    400: '#807DFF',
    500: '#605CFF',
    600: '#4C48FF',
    700: '#4340B3',
    800: '#3A3799',
    900: '#302E80',
    1000: '#131233',
  },
  lime: {
    100: '#EFFCC0',
    200: '#E5F99A',
    300: '#D9F767',
    400: '#CFF541',
    500: '#BFF102',
    600: '#ACD902',
    700: '#99C102',
    800: '#86A901',
    900: '#698401',
    1000: '#4C6001',
  },
  mauve: {
    100: '#F9F1FF',
    200: '#EEDFFE',
    300: '#E7D1FD',
    400: '#D8B5FB',
    500: '#CEA2FA',
    600: '#9071AF',
    700: '#67517D',
    800: '#3E314B',
    900: '#32273C',
    1000: '#200E30',
  },
  lemon: {
    100: '#FFFCF4',
    200: '#FFF9E6',
    300: '#FFF5D5',
    400: '#FFECAD',
    500: '#FCE491',
    600: '#CAB674',
    700: '#978957',
    800: '#655B3A',
    900: '#322E1D',
    1000: '#0D0A00',
  },
  water: {
    100: '#EBF6FD',
    200: '#D7F0FF',
    300: '#B1E3FF',
    400: '#84D3FF',
    500: '#48BCFD',
    600: '#00A3FF',
    700: '#0090E0',
    800: '#0278BA',
    900: '#014063',
    1000: '#002336',
  },
  red: {
    100: '#F7E9E8',
    200: '#F6C6D1',
    300: '#F5A3BB',
    400: '#F46995',
    500: '#F20C59',
    600: '#DA0B50',
    700: '#B60943',
    800: '#910735',
    900: '#550413',
    1000: '#300212',
  },
  coral: {
    100: '#FFECE0',
    200: '#FFDDBE',
    300: '#FFBE8B',
    400: '#FFA363',
    500: '#FF8B47',
    600: '#CD6C2A',
    700: '#9A4F15',
    800: '#683406',
    900: '#351A00',
    1000: '#030100',
  },
  green: {
    100: '#DBEFD9',
    200: '#B9E7BE',
    300: '#8FDE9D',
    400: '#69D57F',
    500: '#3ACB5A',
    600: '#30A84B',
    700: '#26843B',
    800: '#207031',
    900: '#1A5B29',
    1000: '#113D1B',
  },
  burgundy: {
    100: '#EDE1E5',
    200: '#E5D1D7',
    300: '#D9BCC8',
    400: '#CBA4B6',
    500: '#BE8BA3',
    600: '#B07390',
    700: '#9B4E74',
    800: '#872858',
    900: '#73043C',
    1000: '#5C0330',
  },
  indigo: {
    100: '#E2E4EC',
    200: '#D2D6E4',
    300: '#BDC3DA',
    400: '#A5AFD0',
    500: '#8C98C4',
    600: '#7483B8',
    700: '#4F61A7',
    800: '#294196',
    900: '#052185',
    1000: '#041A6A',
  },
  forest: {
    100: '#E2E6E2',
    200: '#D1D8D2',
    300: '#BCC7C0',
    400: '#A3B4AB',
    500: '#8A9F95',
    600: '#728C7F',
    700: '#517263',
    800: '#264F3E',
    900: '#01311D',
    1000: '#012717',
  },
  neutral: {
    0: '#FFFFFF',
    100: '#FBFAF7',
    200: '#F7F5EF',
    300: '#EFEDE3',
    400: '#E1DED0',
    500: '#CFCBB5',
    600: '#A19C87',
    700: '#75715F',
    800: '#45433A',
  },
  white: '#FFFFFF',
  'off-white-1': '#FBFAF7',
  'off-white-2': '#F7F5EF',
  'off-white-3': '#EFEDE3',
}

module.exports = { primitives }
